import { render } from "./vweipages.vue?vue&type=template&id=f73f8e48&scoped=true"
import script from "./vweipages.vue?vue&type=script&lang=js"
export * from "./vweipages.vue?vue&type=script&lang=js"

import "./vweipages.vue?vue&type=style&index=0&id=f73f8e48&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f73f8e48"]])

export default __exports__